<template>
  <div class="home">
    <h1>Profile Page</h1>
    <h4>{{ $route.params.id }}</h4>
  </div>
</template>
